/**
 * Shared types for the Cardholders flow. Mirrors the backend's
 * CardholderResponseDto; the dashboard labels these "Cardholders" in copy
 * while the DB + routes keep the historical `cardholder` / `customer`
 * naming (see docs/design/2026-10-03-dashboard-kyb-and-customers.md §3
 * Decision 4).
 */

export type KycStatus = 'unverified' | 'verified' | 'flagged';
export type CardholderType = 'individual' | 'business';

export interface Cardholder {
  id: string;
  tenantId: string;
  externalRef: string;
  firstName: string;
  lastName: string;
  nameOnCard: string;
  email: string;
  phoneNumber: string;
  accountNumber: string;
  accountName: string;
  addressLine1: string;
  addressLine2: string | null;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
  type: CardholderType | string;
  kycStatus: KycStatus;
  createdAt: string;
  updatedAt: string;
}

export const KYC_STATUS_LABEL: Record<KycStatus, string> = {
  unverified: 'Unverified',
  verified: 'Verified',
  flagged: 'Flagged',
};

export const KYC_STATUS_TONE: Record<KycStatus, string> = {
  unverified: 'bg-notice-tint text-notice',
  verified: 'bg-tally-tint text-tally',
  flagged: 'bg-stop-tint text-stop',
};
